import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { getIsLibraryEventsDisabled, getLibraryDisabled } from '../../data/customer/customerSelectors'
import { getIsUserTeen } from '../../data/user/userSelectors'

// Microsite guest browsing has no age information; other entry points keep the default teen check.
export const useCanViewUngatedEssentialsEvents = ({ skipTeenCheck = false }: { skipTeenCheck?: boolean } = {}) => {
  const { isUngatedEssentialsEventsEnabled } = useFlags()
  const libraryDisabled = useSelector(getLibraryDisabled)
  const eventsDisabled = useSelector(getIsLibraryEventsDisabled)
  const isTeen = useSelector(getIsUserTeen)
  return isUngatedEssentialsEventsEnabled && !libraryDisabled && !eventsDisabled && (skipTeenCheck || !isTeen)
}
